// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sj8LDMCBCXHPRozLGAYD {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background: #f7f8f9;
}
._8t381FvRC7_wjNeVzpXA {
  background: #fff;
  width: 800px;
  padding: 24px;
  border-radius: 5px;
}
.t1KICueyVYrCKcwTJpkk {
  width: 100%;
  margin: 20px auto 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/InviteConfirm/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;AAGA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AADF;AAIA;EACE,WAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAFF","sourcesContent":["\n.container {\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  height: 100vh;\n  justify-content: center;\n  align-items: center;\n  background: #f7f8f9;\n}\n\n.content {\n  background: #fff;\n  width: 800px;\n  padding: 24px;\n  border-radius: 5px;\n}\n\n.join {\n  width: 100%;\n  margin: 20px auto 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Sj8LDMCBCXHPRozLGAYD`,
	"content": `_8t381FvRC7_wjNeVzpXA`,
	"join": `t1KICueyVYrCKcwTJpkk`
};
export default ___CSS_LOADER_EXPORT___;
